import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_NEW_INCIDENT_REPORTS_REQUEST',
  'GET_NEW_INCIDENT_REPORTS_SUCCESS',
  'GET_NEW_INCIDENT_REPORTS_ERROR',
  'GET_QA_INCIDENT_REPORTS_REQUEST',
  'GET_QA_INCIDENT_REPORTS_SUCCESS',
  'GET_QA_INCIDENT_REPORTS_ERROR',
  'GET_RESOLVED_INCIDENT_REPORTS_REQUEST',
  'GET_RESOLVED_INCIDENT_REPORTS_SUCCESS',
  'GET_RESOLVED_INCIDENT_REPORTS_ERROR',
  'GET_IR_PROGRAMS_REQUEST',
  'GET_IR_PROGRAMS_SUCCESS',
  'GET_IR_PROGRAMS_ERROR',
  'GET_IR_DDPS_REQUEST',
  'GET_IR_DDPS_SUCCESS',
  'GET_IR_DDPS_ERROR',
  'GET_IR_PARTICIPANTS_REQUEST',
  'GET_IR_PARTICIPANTS_SUCCESS',
  'GET_IR_PARTICIPANTS_ERROR',
  'CREATE_INCIDENT_REPORT_REQUEST',
  'CREATE_INCIDENT_REPORT_SUCCESS',
  'CREATE_INCIDENT_REPORT_ERROR',
  'REVIEW_INCIDENT_REPORT_REQUEST',
  'REVIEW_INCIDENT_REPORT_SUCCESS',
  'REVIEW_INCIDENT_REPORT_ERROR',
  'QA_INCIDENT_REPORT_REQUEST',
  'QA_INCIDENT_REPORT_SUCCESS',
  'QA_INCIDENT_REPORT_ERROR',
  'EDIT_INCIDENT_REPORT_REQUEST',
  'EDIT_INCIDENT_REPORT_SUCCESS',
  'EDIT_INCIDENT_REPORT_ERROR',
  'GET_PARTICIPANT_IRS_REQUEST',
  'GET_PARTICIPANT_IRS_SUCCESS',
  'GET_PARTICIPANT_IRS_ERROR',
  'GET_EMPLOYEE_IRS_REQUEST',
  'GET_EMPLOYEE_IRS_SUCCESS',
  'GET_EMPLOYEE_IRS_ERROR',
  'PRINT_INCIDENT_REPORT_REQUEST',
  'PRINT_INCIDENT_REPORT_SUCCESS',
  'PRINT_INCIDENT_REPORT_ERROR',
  'PRINT_INCIDENT_REPORTS_REQUEST',
  'PRINT_INCIDENT_REPORTS_SUCCESS',
  'PRINT_INCIDENT_REPORTS_ERROR'
);
